import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PropertyInputComponent } from './properties/abstract-property-input.component';
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-abstract-property-form',
  template: '',
  standalone: false,
})
export abstract class StaticPropertyFormComponent extends PropertyInputComponent {}
